export default "__VITE_ASSET__leh62NwH__"